import { RESET_EVENT_FILES, UPDATE_EVENT_FILES } from './actions'
import { IHubEventBasicFormFilesState } from './contracts'

export const EVENT_BASIC_FORM_FILES_STATE: IHubEventBasicFormFilesState = {
  eventFiles: [],
  deletedEventFiles: []
}
export interface IHubEventBasicFormFilesStateAction {
  type: string
  payload: IHubEventBasicFormFilesState
}

export const HubEventBasicFormFilesReducer = (
  state: IHubEventBasicFormFilesState = EVENT_BASIC_FORM_FILES_STATE,
  action: IHubEventBasicFormFilesStateAction
): any => {
  switch (action.type) {
    case UPDATE_EVENT_FILES:
      return {
        ...state,
        eventFiles: action.payload.eventFiles,
        deletedEventFiles: action.payload.deletedEventFiles,
        homePageSlider: action.payload?.homePageSlider,
        presentationVideo: action.payload?.presentationVideo,
        coverImage: action.payload?.coverImage
      }
    case RESET_EVENT_FILES:
      return {
        ...state,
        eventFiles: [],
        deletedEventFiles: [],
        homePageSlider: undefined,
        presentationVideo: undefined,
        coverImage: undefined
      }
    default:
      return state
  }
}
